import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const comparisons = [{
  feature: 'Alerts at 30+ PPM',
  ours: true,
  theirs: false
}, {
  feature: 'Real-Time PPM Display',
  ours: true,
  theirs: false
}, {
  feature: '4-Stage Color Alert',
  ours: true,
  theirs: false
}, {
  feature: 'Monitors Temp & Humidity',
  ours: true,
  theirs: false
}, {
  feature: 'Sensor Expiration Alert',
  ours: true,
  theirs: false
}, {
  feature: '10-Year Sensor Life',
  ours: true,
  theirs: false
}, {
  feature: 'Plug & Play (no tools)',
  ours: true,
  theirs: false
}, {
  feature: 'CE & FCC Certified',
  ours: true,
  theirs: 'Varies'
}];
export function AuthoritySection() {
  return <section className="w-full bg-bg-alt py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-17">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col" data-id="element-19">
          <h2 className="text-[28px] font-bold text-text-primary mb-3" data-id="element-20">
            Professional-Grade Sensor. Everyday Price.
          </h2>
          <div className="space-y-2.5 text-[16px] text-text-secondary leading-[1.45] mb-5" data-id="element-21">
            <p data-id="element-22">
              Inside every AirGuard Pro is a high-precision sensor — the same
              technology class trusted by HVAC professionals and emergency
              responders in commercial-grade equipment that typically costs $200
              or more.
            </p>
            <p data-id="element-23">
              We made it accessible for every family — without cutting a single
              corner on safety performance.
            </p>
          </div>
          <div className="bg-bg-card rounded-lg border border-border-subtle shadow-card overflow-hidden" data-id="element-24">
            <table className="w-full text-left border-collapse" data-id="element-25">
              <thead data-id="element-26">
                <tr className="border-b border-border-subtle bg-bg-card-alt" data-id="element-27">
                  <th className="py-2 px-4 font-bold text-text-primary text-[14px]" data-id="element-28">
                    Feature
                  </th>
                  <th className="py-2 px-2 font-bold text-text-primary text-center text-[14px]" data-id="element-29">
                    AirGuard Pro
                  </th>
                  <th className="py-2 px-2 font-bold text-text-secondary text-center text-[14px]" data-id="element-30">
                    Traditional
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-31">
                {comparisons.map((row, i) => <tr key={i} className={i < comparisons.length - 1 ? 'border-b border-border-subtle' : ''} data-id="element-32">
                    <td className="py-2 px-4 text-text-secondary text-[14px]" data-id="element-33">
                      {row.feature}
                    </td>
                    <td className="py-2 px-2 text-center" data-id="element-34">
                      <Check className="w-5 h-5 text-accent-green mx-auto" data-id="element-35" />
                    </td>
                    <td className="py-2 px-2 text-center" data-id="element-36">
                      {typeof row.theirs === 'boolean' ? <X className="w-5 h-5 text-accent-red mx-auto" data-id="element-37" /> : <span className="text-text-secondary text-[14px]" data-id="element-38">
                          {row.theirs}
                        </span>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col gap-3" data-id="element-39">
          <img src="https://cdn.magicpatterns.com/uploads/vExBLuKVZ1VHvAJJPFFsLz/foto2.png" alt="Sensor Internals" className="w-full h-auto rounded-xl shadow-card border border-border-subtle" data-id="element-40" />
          <img src="https://cdn.magicpatterns.com/uploads/ouEiANkRJEreWjgNYUeFWs/foto6.png" alt="Product Front" className="w-full h-auto rounded-xl shadow-card border border-border-subtle" data-id="element-41" />
        </motion.div>
      </div>
    </section>;
}